import Swiper from 'swiper'
import { A11y, Controller, EffectFade, Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// Shared by both tracks. They have to agree on count, speed and loop, or the
// controller link below drifts — it syncs by slide index, and turning `loop`
// on for one of them would renumber that track by injecting cloned slides at
// both ends. `loop: false` is also what lets Navigation mark itself disabled at
// the first and last slide, which the arrows are styled against.
const SHARED = {
    modules: [A11y, Controller, EffectFade, Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    speed: 500,
}

/**
 * Highlight carousel — two tracks moving as one. The photo column slides while
 * the copy column cross-fades, which is why they can't be a single Swiper with
 * one slide per highlight.
 *
 * The photo track owns the arrows and pagination and drives the copy track
 * through Swiper's controller. A11y names each region and numbers the slides
 * ("Slide 2 of 5"); the markup carries the arrow labels as a no-JS baseline.
 */
export function initHighlightCarousel() {
    if (!document.querySelector('.highlight-images')) return

    const content = new Swiper('.highlight-content', {
        ...SHARED,
        effect: 'fade',
        // Without crossFade the outgoing slide stays opaque until the incoming
        // one has finished, so the two titles overlap mid-transition.
        fadeEffect: { crossFade: true },
        // The copy follows the photos; dragging it directly would fight them.
        allowTouchMove: false,
        a11y: { containerMessage: 'Highlight details' },
    })

    new Swiper('.highlight-images', {
        ...SHARED,
        navigation: {
            prevEl: '.highlight-prev',
            nextEl: '.highlight-next',
        },
        pagination: {
            el: '.highlight-pagination',
            clickable: true,
        },
        a11y: { containerMessage: 'Project highlights' },
        controller: { control: content },
    })
}
